import type { MaterialPool } from './material-pool.interface';
import type { TaskInstance } from './task-instance.interface';

export interface TaskMaterialPool {
    C_MaterialPool_key: number;
    C_TaskInstance_key: number;
    C_TaskMaterialPool_key: number;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    MaterialPool: MaterialPool;
    ModifiedBy: string;
    Sequence: number;
    TaskInstance: TaskInstance;
    Version: number;
}
